import Vue from 'vue'
import VueRouter from 'vue-router'
import TheLayout from '@/containers/TheLayout.vue'
import store from '../store'

Vue.use(VueRouter)

const routes = [
  {
    path: '*',
    name: 'page-not-found',
    component: () => import(/* webpackChunkName: "404" */ '@/views/404/404.vue')
  },
  {
    path: '/',
    redirect: '/dashboard',
    component: TheLayout,
    children: [
      {
        path: '/dashboard',
        name: 'Dashboard',
        meta: {
          submenu: false
        },
        component: () => import(/* webpackChunkName: "Dashboard" */ '../views/Dashboard/Dashboard.vue')
      },
      {
        path: '/order',
        name: 'Order',
        meta: {
          submenu: false
        },
        component: () => import(/* webpackChunkName: "Order" */ '../views/Order/Order.vue')
      },
      {
        path: '/order/step/upload',
        name: 'Create Order - Upload',
        meta: {
          submenu: false
        },
        component: () => import(/* webpackChunkName: "OrderShipping" */ '../views/Order/CreateOrderUpload.vue')
      },
      {
        path: '/order/step/upload/:id/edit',
        name: 'Create Order - Upload',
        meta: {
          submenu: false
        },
        component: () => import(/* webpackChunkName: "OrderShipping" */ '../views/Order/EditTempOrder.vue')
      },
      {
        path: '/order/step/shipping',
        name: 'Create Order - Shipping',
        meta: {
          submenu: false
        },
        component: () => import(/* webpackChunkName: "OrderShipping" */ '../views/Order/CreateOrderShipping.vue')
      },
      {
        path: '/order/step/logistic',
        name: 'Create Order - Logistic',
        meta: {
          submenu: false
        },
        component: () => import(/* webpackChunkName: "OrderLogistic" */ '../views/Order/CreateOrderLogistic.vue')
      },
      {
        path: '/order/step/confirmation',
        name: 'Create Order - Confirmation',
        meta: {
          submenu: false
        },
        component: () => import(/* webpackChunkName: "OrderConfirmation" */ '../views/Order/CreateOrderConfirmation.vue')
      },
      {
        path: '/order/detail/:id',
        name: 'Order Detail',
        component: () => import(/* webpackChunkName: "OrderDetail" */ '../views/Order/OrderDetail.vue')
      },
      {
        path: '/order/pickup',
        name: 'Order Pickup',
        meta: {
          submenu: false
        },
        component: () => import(/* webpackChunkName: "Order" */ '../views/Order/RequestPickup.vue')
      },
      {
        path: '/order/pickup/detail/:id',
        name: 'Order Pickup Detail',
        meta: {
          submenu: false
        },
        component: () => import(/* webpackChunkName: "Order" */ '../views/Order/RequestPickupDetail.vue')
      },
      {
        path: '/profile',
        name: 'Profile',
        component: () => import(/* webpackChunkName: "PackageDetail" */ '../views/Profile/Profile.vue')
      },
      {
        path: '/tracking',
        name: 'Tracking',
        meta: {
          submenu: false
        },
        component: () => import(/* webpackChunkName: "Tracking" */ '../views/Tracking/Tracking.vue')
      },
      {
        path: '/tracking/:id',
        name: 'Tracking Detail',
        meta: {
          submenu: false
        },
        component: () => import(/* webpackChunkName: "TrackingDetail" */ '../views/Tracking/TrackingDetail.vue')
      },
      {
        path: '/ongkir',
        name: 'Ongkir',
        meta: {
          submenu: false
        },
        component: () => import(/* webpackChunkName: "Ongkir" */ '../views/Tracking/Ongkir.vue')
      },
      {
        path: '/ongkir/create',
        name: 'Ongkir Create Order',
        meta: {
          submenu: false
        },
        component: () => import(/* webpackChunkName: "OngkirCreateOrder" */ '../views/Tracking/OngkirCreateOrder.vue')
      },
      {
        path: '/report',
        name: 'Report',
        meta: {
          submenu: false
        },
        component: () => import(/* webpackChunkName: "Report" */ '../views/Income/Income.vue')
      },
      {
        path: '/admin',
        name: 'Admin',
        meta: {
          submenu: false
        },
        component: () => import(/* webpackChunkName: "AdminList" */ '../views/Admin/AdminList.vue')
      },
      {
        path: '/admin/create',
        name: 'Create Admin',
        meta: {
          submenu: false
        },
        component: () => import(/* webpackChunkName: "CreateAdmin" */ '../views/Admin/CreateAdmin.vue')
      },
      {
        path: '/admin/detail/:id',
        name: 'Admin Detail',
        meta: {
          submenu: false
        },
        component: () => import(/* webpackChunkName: "AdminDetail" */ '../views/Admin/AdminDetail.vue')
      },
      {
        path: '/address',
        name: 'Address',
        meta: {
          submenu: false
        },
        component: () => import(/* webpackChunkName: "Address" */ '../views/AddressList/AddressList.vue')
      },
      {
        path: '/voucher',
        name: 'Voucher',
        meta: {
          submenu: false
        },
        component: () => import(/* webpackChunkName: "Voucher" */ '../views/Voucher/VoucherList.vue')
      },
      {
        path: '/ai-agent',
        name: 'AI Agent',
        meta: {
          submenu: false
        },
        component: () => import(/* webpackChunkName: "AIAgent" */ '../views/AIAgent/chat.vue')
      },
      {
        path: '/open-api',
        name: 'Open API',
        meta: {
          submenu: false
        },
        component: () => import(/* webpackChunkName: "OpenApi" */ '../views/OpenApi/OpenApi.vue')
      },
    ]
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "Login" */ '../views/Login/Login.vue')
  },
  {
    path: '/reset-password',
    name: 'Reset Password',
    component: () => import(/* webpackChunkName: "ResetPassword" */ '../views/Login/ResetPassword.vue')
  },
  {
    path: '/reset-password/:token',
    name: 'Reset Password Token',
    component: () => import(/* webpackChunkName: "ResetPasswordToken" */ '../views/Login/ResetPassword.vue')
  },
  {
    path: '/registration',
    name: 'Registration',
    component: () => import(/* webpackChunkName: "Registration" */ '../views/Registration/Registration.vue')
  },
  {
    path: '/verification-error',
    name: 'Verification Error',
    component: () => import(/* webpackChunkName: "VerificationError" */ '../views/Verification/VerificationError.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  store.dispatch('auth/getCurrentUser')
  const tokenExpire = store.getters['auth/userData']?.token?.expired_at
  if (new Date().getTime() > new Date(tokenExpire).getTime()) {
    store.dispatch('auth/removeUserData')
    next({
      name: 'Login'
    })
    return
  }
  if (!store.getters['auth/isLoggedIn'] && to.name !== 'Login' && to.name !== 'Registration' && to.name !== 'Verification Error' && to.name !== 'Reset Password Token') {
    next({
      name: 'Login'
    })
    return
  }
  if (store.getters['auth/isLoggedIn'] && to.name === 'Login') {
    next({
      name: 'Order'
    })
    return
  }
  if (store.getters['auth/isLoggedIn'] && to.name !== 'Reset Password' && store.getters['auth/userData']?.user?.require_change_password) {
    next({
      name: 'Reset Password'
    })
    return
  }
  if (store.getters['auth/isLoggedIn'] && to.name === 'Reset Password' && !store.getters['auth/userData']?.user?.require_change_password) {
    next({
      name: 'Order'
    })
    return
  }

  next()
})

router.afterEach((to, from) => {
  if (store.getters['common/isMobile']) {
    store.dispatch('common/expandMenu', true)
  }
})

export default router
